let data = {
    "CompanyType": [
        { "CategoryID": 1100, "CategoryTitle": "企事业单位", "CategoryCode": "EnterprisesUnit" },
        { "CategoryID": 1101, "CategoryTitle": "政府机关", "CategoryCode": "GovernmentDepartment" }
    ],
    "CapitalType": [
        { "CategoryID": 1102, "CategoryTitle": "民营资产", "CategoryCode": "PeopleEnterprises" },
        { "CategoryID": 1103, "CategoryTitle": "国有资产", "CategoryCode": "CountryCapital" },
        { "CategoryID": 1104, "CategoryTitle": "中外合资", "CategoryCode": "ChinaOuterJoinCapital" },
        { "CategoryID": 1105, "CategoryTitle": "外商独资", "CategoryCode": "ForeignCompany" }
    ],
    "CompanySize": [
        { "CategoryID": 1106, "CategoryTitle": "100人以下", "CategoryCode": "CompanySize100" },
        { "CategoryID": 1107, "CategoryTitle": "100~499", "CategoryCode": "CompanySize499" },
        { "CategoryID": 1108, "CategoryTitle": "500~999", "CategoryCode": "CompanySize999" },
        { "CategoryID": 1109, "CategoryTitle": "1000~4999", "CategoryCode": "CompanySize4999" },
        { "CategoryID": 1110, "CategoryTitle": "5000以上", "CategoryCode": "CompanySize5kUp" }
    ],
    "ApplyArea": [
        { "CategoryID": 1126, "CategoryTitle": "国内", "CategoryCode": "Internal" },
        { "CategoryID": 1127, "CategoryTitle": "国际", "CategoryCode": "Overseas" }
    ],
    "CardType": [
        { "CategoryID": 1138, "CategoryTitle": "身份证", "CategoryCode": "IDCard" },
        { "CategoryID": 1139, "CategoryTitle": "护照", "CategoryCode": "PassportCard" },
        { "CategoryID": 1140, "CategoryTitle": "学生证", "CategoryCode": "StudentCard" },
        { "CategoryID": 1141, "CategoryTitle": "军人证", "CategoryCode": "OfficerCard" },

        { "CategoryID": 1296, "CategoryTitle": "港澳台居民居住证", "CategoryCode": "Residencepermit" },
        { "CategoryID": 1297, "CategoryTitle": "外国人永久居留身份证", "CategoryCode": "ForeignResidentIDCard" },
        { "CategoryID": 1234, "CategoryTitle": "港澳通行证", "CategoryCode": "HKCompatriotsyndrome" },
        { "CategoryID": 1233, "CategoryTitle": "台湾通行证", "CategoryCode": "TaiCompatriotsyndrome" },

        { "CategoryID": 1298, "CategoryTitle": "回乡证", "CategoryCode": "HKMpermit" },
        { "CategoryID": 1299, "CategoryTitle": "台胞证", "CategoryCode": "TaiWpermit" },

        // { "CategoryID": 1142, "CategoryTitle": "其它", "CategoryCode": "OtherCard" },
    ],
    "UserStatus": [
        { "CategoryID": 1143, "CategoryTitle": "启用", "CategoryCode": "Enable" },
        { "CategoryID": 1144, "CategoryTitle": "禁用", "CategoryCode": "UnEnable" }
    ],
    "Sex": [
        { "CategoryID": 1145, "CategoryTitle": "男", "CategoryCode": "Male" },
        { "CategoryID": 1146, "CategoryTitle": "女", "CategoryCode": "Female" }
    ],
    "YesOrNo": [
        { "CategoryID": 1150, "CategoryTitle": "是", "CategoryCode": "Yes" },
        { "CategoryID": 1151, "CategoryTitle": "否", "CategoryCode": "No" }
    ],
    "ChinaVoyageType": [
        { "CategoryID": 1161, "CategoryTitle": "单程", "CategoryCode": "SingleVoyage" },
        { "CategoryID": 1162, "CategoryTitle": "往返", "CategoryCode": "RoundVoyage" },
        // { "CategoryID": 1163, "CategoryTitle": "回程", "CategoryCode": "ReturnVoyage" },
        // { "CategoryID": 1167, "CategoryTitle": "联程", "CategoryCode": "ConnectVoyage" }
    ],
    "RoleType": [
        { "CategoryID": 1311, "CategoryTitle": "用户", "CategoryCode": "User" },
        { "CategoryID": 1312, "CategoryTitle": "职位", "CategoryCode": "Jobs" },
        { "CategoryID": 1313, "CategoryTitle": "群组", "CategoryCode": "Group" },
        { "CategoryID": 1314, "CategoryTitle": "部门", "CategoryCode": "Department" },
        { "CategoryID": 1315, "CategoryTitle": "公司", "CategoryCode": "Company" },
        { "CategoryID": 1316, "CategoryTitle": "服务", "CategoryCode": "Service" },
        { "CategoryID": 1317, "CategoryTitle": "客户", "CategoryCode": "Customer" },
        { "CategoryID": 1318, "CategoryTitle": "权限", "CategoryCode": "Action" },
        { "CategoryID": 1319, "CategoryTitle": "成本中心", "CategoryCode": "CostCenter" },
    ],
    "HotelPayType": [
        { "CategoryID": 1195, "CategoryTitle": "预付", "CategoryCode": "HotelPrepay" },
        { "CategoryID": 1196, "CategoryTitle": "现付", "CategoryCode": "HotelCashPay" }
    ],
    "FlightType": [
        { "CategoryID": 1193, "CategoryTitle": "普通航班", "CategoryCode": "CommonFlight" },
        { "CategoryID": 1194, "CategoryTitle": "共享航班", "CategoryCode": "ShareFlight" }
    ],
    "ConsumerType": [
        { "CategoryID": 1701, "CategoryTitle": "婴儿", "CategoryCode": "Infant" },
        { "CategoryID": 1703, "CategoryTitle": "儿童", "CategoryCode": "Enfant" },
        { "CategoryID": 1705, "CategoryTitle": "成人", "CategoryCode": "Young" },
        { "CategoryID": 1707, "CategoryTitle": "中年", "CategoryCode": "Wrinkly" },
        { "CategoryID": 1709, "CategoryTitle": "老年", "CategoryCode": "Elderly" },
    ],
    "BillCycle": [
        { "CategoryID": 1260, "CategoryTitle": "月", "CategoryCode": "MonthCycle" },
        { "CategoryID": 1261, "CategoryTitle": "周", "CategoryCode": "WeekCycle" },
        { "CategoryID": 1262, "CategoryTitle": "日", "CategoryCode": "DayCycle" }
    ],
    "ServiceMode": [
        { "CategoryID": 1300, "CategoryTitle": "线上服务", "CategoryCode": "OnlineServiceMode" },
        { "CategoryID": 1301, "CategoryTitle": "线下服务", "CategoryCode": "LineServiceMode" }
    ],
    "CalcPriceMode": [
        { "CategoryID": 1302, "CategoryTitle": "百分比", "CategoryCode": "PercentageMode" },
        { "CategoryID": 1303, "CategoryTitle": "固定金额", "CategoryCode": "FixedPrice" }
    ],
    "CalcBenchmark": [
        { "CategoryID": 1304, "CategoryTitle": "票面价", "CategoryCode": "ExpensePrice" },
        { "CategoryID": 1305, "CategoryTitle": "票面价+税费", "CategoryCode": "PriceFareAndTax" }
    ],
    "RuntimeEnvironment": [
        { "CategoryID": 1320, "CategoryTitle": "服务端", "CategoryCode": "Server" },
        { "CategoryID": 1321, "CategoryTitle": "客户端", "CategoryCode": "Client" }
    ],
    "WorkStatus": [
        { "CategoryID": 1325, "CategoryTitle": "正常", "CategoryCode": "Normal" },
        { "CategoryID": 1326, "CategoryTitle": "变更", "CategoryCode": "Change" }
    ],
    "DataRange": [
        { "CategoryID": 1332, "CategoryTitle": "不限制", "CategoryCode": "NoLimit" },
        { "CategoryID": 1330, "CategoryTitle": "仅自己", "CategoryCode": "SelfOnly" },
        // { "CategoryID": 1331, "CategoryTitle": "自己及下级", "CategoryCode": "SelfLower" },
        { "CategoryID": 1513, "CategoryTitle": "本部门", "CategoryCode": "Department" },
        { "CategoryID": 1514, "CategoryTitle": "本部门及下级", "CategoryCode": "DepartmentLower" }
    ],
    "AuthorizeState": [
        { "CategoryID": 1335, "CategoryTitle": "未授权", "CategoryCode": "UnAuthorized" },
        { "CategoryID": 1336, "CategoryTitle": "已授权", "CategoryCode": "Authorized" }
    ],
    "RoleCategory": [
        { "CategoryID": 1350, "CategoryTitle": "系统角色", "CategoryCode": "SystemRole" },
        { "CategoryID": 1351, "CategoryTitle": "用户角色", "CategoryCode": "UserRole" }
    ],
    "EventType": [
        { "CategoryID": 1356, "CategoryTitle": "继续之前", "CategoryCode": "ContinueBefore" },
        { "CategoryID": 1357, "CategoryTitle": "继续之后", "CategoryCode": "ContinueAfter" },
        { "CategoryID": 1358, "CategoryTitle": "退回之前", "CategoryCode": "ReturnBefore" },
        { "CategoryID": 1359, "CategoryTitle": "退回之后", "CategoryCode": "ReturnAfter" },
        { "CategoryID": 1360, "CategoryTitle": "变更之前", "CategoryCode": "ChangeBefore" },
        { "CategoryID": 1361, "CategoryTitle": "变更之后", "CategoryCode": "ChangeAfter" }
    ],
    "InvoiceStatus": [
        { "CategoryID": 1362, "CategoryTitle": "需要发票", "CategoryCode": "NeedInvoice" },
        { "CategoryID": 1363, "CategoryTitle": "不要发票", "CategoryCode": "NoInvoice" }
    ],
    "CreateMode": [
        { "CategoryID": 1364, "CategoryTitle": "网站", "CategoryCode": "WEB" },
    ],
    "UnitPrice": [
        { "CategoryID": 1369, "CategoryTitle": "元", "CategoryCode": "RMB" },
        { "CategoryID": 1370, "CategoryTitle": "美元", "CategoryCode": "Dollar" }
    ],
    "TradeMode": [
        { "CategoryID": 1371, "CategoryTitle": "支付宝", "CategoryCode": "Alipay" },
        { "CategoryID": 1372, "CategoryTitle": "微信", "CategoryCode": "WeChat" },
        { "CategoryID": 1373, "CategoryTitle": "现金", "CategoryCode": "Cash" },
        { "CategoryID": 1374, "CategoryTitle": "月结", "CategoryCode": "Monthly" },
        { "CategoryID": 1376, "CategoryTitle": "POS", "CategoryCode": "Pos" },
        { "CategoryID": 1483, "CategoryTitle": "转账", "CategoryCode": "Transfer" },
    ],
    "ProductType": [
        { "CategoryID": 1375, "CategoryTitle": "旅游", "CategoryCode": "Tour" },
        { "CategoryID": 1376, "CategoryTitle": "酒店", "CategoryCode": "Hotel" },
        { "CategoryID": 1377, "CategoryTitle": "机票", "CategoryCode": "Flight" },
        { "CategoryID": 1484, "CategoryTitle": "火车票", "CategoryCode": "Train" }
    ],
    "FileType": [
        { "CategoryID": 1378, "CategoryTitle": "出团通知书", "CategoryCode": "AdviceNote" },
        { "CategoryID": 1379, "CategoryTitle": "客人附件", "CategoryCode": "GuestEnclosure" },
        { "CategoryID": 1381, "CategoryTitle": "其他", "CategoryCode": "other" },
        { "CategoryID": 1382, "CategoryTitle": "电子合同", "CategoryCode": "Electronic" }
    ],
    "MessageType": [
        { "CategoryID": 1383, "CategoryTitle": "给客人留言", "CategoryCode": "ClientMessage" },
        { "CategoryID": 1384, "CategoryTitle": "给供应留言", "CategoryCode": "SupplyMessage" },
        { "CategoryID": 1385, "CategoryTitle": "给同事留言", "CategoryCode": "WorkmateMessage" }
    ],
    "TravelStatus": [
        { "CategoryID": 1390, "CategoryTitle": "已出游", "CategoryCode": "Traveled" },
        { "CategoryID": 1391, "CategoryTitle": "未出游", "CategoryCode": "NotTravel" }
    ],
    "OrderType": [
        { "CategoryID": 1397, "CategoryTitle": "销售", "CategoryCode": "Sell" },
        { "CategoryID": 1398, "CategoryTitle": "退款", "CategoryCode": "DrawBack" }
    ],
    "BusinessType": [
        { "CategoryID": 1797, "CategoryTitle": "销售", "CategoryCode": "Sales" },
        { "CategoryID": 1789, "CategoryTitle": "变更", "CategoryCode": "Change" },
        { "CategoryID": 1799, "CategoryTitle": "退废", "CategoryCode": "Amend" },
        { "CategoryID": 1791, "CategoryTitle": "账务", "CategoryCode": "Bill" },
        { "CategoryID": 1792, "CategoryTitle": "发票", "CategoryCode": "Invoice" },
        { "CategoryID": 1793, "CategoryTitle": "公司", "CategoryCode": "Company" },
        { "CategoryID": 1795, "CategoryTitle": "产品", "CategoryCode": "Product" },
        { "CategoryID": 1801, "CategoryTitle": "个人", "CategoryCode": "People" }
        // { "CategoryID": 1395, "CategoryTitle": "变更", "CategoryCode": "Change" },
        // { "CategoryID": 1397, "CategoryTitle": "销售", "CategoryCode": "Sales" },
        // { "CategoryID": 1398, "CategoryTitle": "退款", "CategoryCode": "Refund" }
    ],
    "SecurityType": [
        { "CategoryID": 1399, "CategoryTitle": "登录密码", "CategoryCode": "PasswordVerify" },
        { "CategoryID": 1400, "CategoryTitle": "邮箱验证", "CategoryCode": "EmailVerify" },
        { "CategoryID": 1401, "CategoryTitle": "手机验证", "CategoryCode": "PhoneVerify" },
        { "CategoryID": 1402, "CategoryTitle": "实名验证", "CategoryCode": "NameVerify" },
        { "CategoryID": 1403, "CategoryTitle": "安全问题", "CategoryCode": "SafetyProblem" }
    ],
    "Source": [
        { "CategoryID": 1404, "CategoryTitle": "网站", "CategoryCode": "Pc" },
        { "CategoryID": 1405, "CategoryTitle": "手机", "CategoryCode": "App" },
        { "CategoryID": 1803, "CategoryTitle": "客服", "CategoryCode": "Customer" },
        { "CategoryID": 1984, "CategoryTitle": "需求", "CategoryCode": "Demand" }
    ],
    "ServiceType": [
        { "CategoryID": 0, "CategoryTitle": "通用服务", "CategoryCode": "CommonService" },
        { "CategoryID": 1407, "CategoryTitle": "酒店服务", "CategoryCode": "HotelService" },
        { "CategoryID": 1408, "CategoryTitle": "旅游服务", "CategoryCode": "TourService" },
        { "CategoryID": 1409, "CategoryTitle": "机票服务", "CategoryCode": "FlightService" },
        { "CategoryID": 1470, "CategoryTitle": "火车服务", "CategoryCode": "TrainService" },
        { "CategoryID": 1555, "CategoryTitle": "交通服务", "CategoryCode": "TrafficService" },
        { "CategoryID": 1406, "CategoryTitle": "商旅服务", "CategoryCode": "BtripService" },
        { "CategoryID": 1466, "CategoryTitle": "保险服务", "CategoryCode": "InsuranceService" },
        { "CategoryID": 1467, "CategoryTitle": "快递服务", "CategoryCode": "ExpressService" },
        { "CategoryID": 1468, "CategoryTitle": "发票服务", "CategoryCode": "InvoiceService" },
        { "CategoryID": 1469, "CategoryTitle": "签证服务", "CategoryCode": "VisaService" },
        { "CategoryID": 1554, "CategoryTitle": "餐饮服务", "CategoryCode": "CaterService" },
        { "CategoryID": 1556, "CategoryTitle": "商城服务", "CategoryCode": "TicketService" },
        { "CategoryID": 1557, "CategoryTitle": "基础服务", "CategoryCode": "BaseService" },
        { "CategoryID": 1636, "CategoryTitle": "系统服务", "CategoryCode": "SystemService" },
        { "CategoryID": 1637, "CategoryTitle": "工作服务", "CategoryCode": "WorkService" },
        { "CategoryID": 1638, "CategoryTitle": "订单服务", "CategoryCode": "OrderService" },
        { "CategoryID": 1640, "CategoryTitle": "账单服务", "CategoryCode": "BillService" },
        { "CategoryID": 1643, "CategoryTitle": "个人服务", "CategoryCode": "UserService" },
        { "CategoryID": 1645, "CategoryTitle": "企业服务", "CategoryCode": "CompanyService" },
        { "CategoryID": 1410, "CategoryTitle": "增值服务", "CategoryCode": "ChargeService" },
    ],
    "ProblemType": [
        { "CategoryID": 1411, "CategoryTitle": "高中班主任是谁", "CategoryCode": "HightDirector" },
        { "CategoryID": 1412, "CategoryTitle": "第一次通关的游戏", "CategoryCode": "Firstgame" }
    ],
    "ContactType": [
        { "CategoryID": 1413, "CategoryTitle": "手机", "CategoryCode": "PhoneContact" },
        { "CategoryID": 1414, "CategoryTitle": "电话", "CategoryCode": "TelephoneContact" },
        { "CategoryID": 1415, "CategoryTitle": "邮箱", "CategoryCode": "EmailContact" },
        { "CategoryID": 1416, "CategoryTitle": "QQ", "CategoryCode": "QQ" }
    ],
    "SetsType": [
        { "CategoryID": 1417, "CategoryTitle": "网上预订须知", "CategoryCode": "OnlineKnow" },
        { "CategoryID": 1418, "CategoryTitle": "国内旅游预订须知", "CategoryCode": "TourKnow" }
    ],
    "TeamStatus": [
        { "CategoryID": 1419, "CategoryTitle": "启用", "CategoryCode": "Enable" },
        { "CategoryID": 1420, "CategoryTitle": "禁用", "CategoryCode": "UnEnable" }
    ],
    "PriceStatus": [
        { "CategoryID": 1421, "CategoryTitle": "价格启用", "CategoryCode": "PriceEnable" },
        { "CategoryID": 1422, "CategoryTitle": "价格禁用", "CategoryCode": "PriceUnEnable" },
        { "CategoryID": 1423, "CategoryTitle": "价格待定", "CategoryCode": "Indeterminate" }
    ],
    "PolicyType": [
        { "CategoryID": 1426, "CategoryTitle": "私有政策", "CategoryCode": "PrivatePolicy" },
        { "CategoryID": 1427, "CategoryTitle": "公有政策", "CategoryCode": "PublicPolicy" }
    ],
    "TradeType": [
        { "CategoryID": 1428, "CategoryTitle": "收款", "CategoryCode": "Receive" },
        { "CategoryID": 1429, "CategoryTitle": "付款", "CategoryCode": "Payment" }
    ],
    "TradeStatus": [
        { "CategoryID": 1610, "CategoryTitle": "待提交", "CategoryCode": "WaitSubmit" },
        { "CategoryID": 1612, "CategoryTitle": "待付款", "CategoryCode": "WaitPayment" },
        { "CategoryID": 1614, "CategoryTitle": "未确认", "CategoryCode": "WaitConfirm" },
        { "CategoryID": 1616, "CategoryTitle": "已确认", "CategoryCode": "Finished" },
        { "CategoryID": 1618, "CategoryTitle": "已取消", "CategoryCode": "Canceled" },
        { "CategoryID": 1620, "CategoryTitle": "已退回", "CategoryCode": "Rejected" },
    ],
    "AuditStatus": [
        { "CategoryID": 1434, "CategoryTitle": "未审批", "CategoryCode": "Unaudit" },
        { "CategoryID": 1435, "CategoryTitle": "已审批", "CategoryCode": "Audited" },
        { "CategoryID": 1436, "CategoryTitle": "审批拒绝", "CategoryCode": "AuditRefuse" }
    ],
    "ApplyStatus": [
        { "CategoryID": 1432, "CategoryTitle": "未提交", "CategoryCode": "Unsubmit" },
        { "CategoryID": 1433, "CategoryTitle": "已提交", "CategoryCode": "Submited" }
    ],
    "RefundStatus": [
        { "CategoryID": 1438, "CategoryTitle": "未处理", "CategoryCode": "Untreated" },
        { "CategoryID": 1439, "CategoryTitle": "退团失败", "CategoryCode": "RefundeBad" },
        { "CategoryID": 1440, "CategoryTitle": "退团处理中", "CategoryCode": "RefundeIng" },
        { "CategoryID": 1441, "CategoryTitle": "退团成功", "CategoryCode": "Refunded" }
    ],
    "ZoneType": [
        { "CategoryID": 1442, "CategoryTitle": "国家", "CategoryCode": "Country" },
        { "CategoryID": 1443, "CategoryTitle": "景区", "CategoryCode": "Scenic" },
        { "CategoryID": 1444, "CategoryTitle": "城市", "CategoryCode": "City" },
        { "CategoryID": 1445, "CategoryTitle": "省份", "CategoryCode": "Province" },
        { "CategoryID": 1446, "CategoryTitle": "区域", "CategoryCode": "Area" },
        { "CategoryID": 1447, "CategoryTitle": "机场", "CategoryCode": "Airport" },
        { "CategoryID": 1448, "CategoryTitle": "洲际", "CategoryCode": "Continent" },
        { "CategoryID": 1449, "CategoryTitle": "区县", "CategoryCode": "District" },
        { "CategoryID": 1807, "CategoryTitle": "车站", "CategoryCode": "Station" },
        { "CategoryID": 1809, "CategoryTitle": "商圈", "CategoryCode": "Business" }
    ],
    "TicketDelivery": [
        { "CategoryID": 1450, "CategoryTitle": "自取", "CategoryCode": "Invite" },
        { "CategoryID": 1451, "CategoryTitle": "邮寄", "CategoryCode": "Mail" }
    ],
    "TicketType": [
        { "CategoryID": 1164, "CategoryTitle": "BSP", "CategoryCode": "BSP" },
        { "CategoryID": 1165, "CategoryTitle": "B2B", "CategoryCode": "B2B" },
        { "CategoryID": 1980, "CategoryTitle": "B2C", "CategoryCode": "B2C" },
        { "CategoryID": 1982, "CategoryTitle": "B2G", "CategoryCode": "B2G" },
        { "CategoryID": 1983, "CategoryTitle": "BSG", "CategoryCode": "BSG" },
        { "CategoryID": 1166, "CategoryTitle": "境外电子", "CategoryCode": "OverseasElectronic" },
        { "CategoryID": 1981, "CategoryTitle": "销售策略", "CategoryCode": "SAP" },
    ],
    "BackAirportType": [
        { "CategoryID": 1180, "CategoryTitle": "同一洲际范围内", "CategoryCode": "WithinIntercontinental" },
        { "CategoryID": 1181, "CategoryTitle": "政策始发机场范围", "CategoryCode": "PolicyDepartAirport" },
        { "CategoryID": 1184, "CategoryTitle": "必须返回行程出发机场", "CategoryCode": "MustBackAirport" },
        { "CategoryID": 1185, "CategoryTitle": "指定返回国家或机场范围", "CategoryCode": "AppointBackAirport" }
    ],
    "ApplicableObject": [
        { "CategoryID": 1168, "CategoryTitle": "团队", "CategoryCode": "Team" },
        { "CategoryID": 1169, "CategoryTitle": "散客", "CategoryCode": "Fit" },
        { "CategoryID": 1170, "CategoryTitle": "不限", "CategoryCode": "Unlimited" }
    ],
    "ApplyPrice": [
        { "CategoryID": 1171, "CategoryTitle": "高开", "CategoryCode": "HighOpen" },
        { "CategoryID": 1172, "CategoryTitle": "低开", "CategoryCode": "DownOpen" }
    ],
    "ApplyWeek": [
        { "CategoryID": 1173, "CategoryTitle": "一", "CategoryCode": "Monday" },
        { "CategoryID": 1174, "CategoryTitle": "二", "CategoryCode": "Tuesday" },
        { "CategoryID": 1175, "CategoryTitle": "三", "CategoryCode": "Wednesday" },
        { "CategoryID": 1176, "CategoryTitle": "四", "CategoryCode": "Thursday" },
        { "CategoryID": 1177, "CategoryTitle": "五", "CategoryCode": "Friday" },
        { "CategoryID": 1178, "CategoryTitle": "六", "CategoryCode": "Saturday" },
        { "CategoryID": 1179, "CategoryTitle": "日", "CategoryCode": "Sunday" }
    ],
    "LimitPassageType": [
        { "CategoryID": 1200, "CategoryTitle": "留学生", "CategoryCode": "OverseasStudent" },
        { "CategoryID": 1201, "CategoryTitle": "移民", "CategoryCode": "Immigrant" },
        { "CategoryID": 1202, "CategoryTitle": "劳工", "CategoryCode": "Worker" },
        { "CategoryID": 1203, "CategoryTitle": "海员", "CategoryCode": "Seaman" },
        { "CategoryID": 1204, "CategoryTitle": "青年", "CategoryCode": "Youth" },
        { "CategoryID": 1205, "CategoryTitle": "港澳台", "CategoryCode": "HkMacaoTw" },
        { "CategoryID": 1206, "CategoryTitle": "外籍", "CategoryCode": "ForeignNationality" },
        { "CategoryID": 1207, "CategoryTitle": "非汉字姓名", "CategoryCode": "NotChineseName" },
        { "CategoryID": 1208, "CategoryTitle": "Add-On", "CategoryCode": "AddOn" },
        { "CategoryID": 1209, "CategoryTitle": "老年", "CategoryCode": "OldGge" },
        { "CategoryID": 1210, "CategoryTitle": "境外中转", "CategoryCode": "OverseasTransfer" },
        { "CategoryID": 1211, "CategoryTitle": "缺口程", "CategoryCode": "NotchRange" },
        { "CategoryID": 1212, "CategoryTitle": "OPEN", "CategoryCode": "OPEN" },
        { "CategoryID": 1213, "CategoryTitle": "SPA", "CategoryCode": "SPA" },
        { "CategoryID": 1214, "CategoryTitle": "Q值", "CategoryCode": "QValue" },
        { "CategoryID": 1215, "CategoryTitle": "共享航班", "CategoryCode": "SharedFlight" },
        { "CategoryID": 1216, "CategoryTitle": "三方协议", "CategoryCode": "ThreeAgreement" },
        { "CategoryID": 1217, "CategoryTitle": "套票", "CategoryCode": "Package" },
        { "CategoryID": 1218, "CategoryTitle": "整团", "CategoryCode": "WholeGroup" },
        { "CategoryID": 1219, "CategoryTitle": "小团", "CategoryCode": "SmallGroup" }
    ],
    "FreightBasicsRule": [
        { "CategoryID": 1182, "CategoryTitle": "无奖励", "CategoryCode": "NoReward" },
        { "CategoryID": 1183, "CategoryTitle": "无代理费", "CategoryCode": "AgencyFreeFee" }
    ],
    "ChildrewardRules": [
        { "CategoryID": 1220, "CategoryTitle": "奖励与成人一样", "CategoryCode": "RewardsAdults" },
        { "CategoryID": 1221, "CategoryTitle": "可无开奖励", "CategoryCode": "NoOpenBonus" },
        { "CategoryID": 1463, "CategoryTitle": "可开无代理费", "CategoryCode": "openAgencyFee" },
        { "CategoryID": 1464, "CategoryTitle": "不可开", "CategoryCode": "NoWay" }
    ],
    "BabywardRules": [
        { "CategoryID": 1222, "CategoryTitle": "可开无奖励", "CategoryCode": "WithoutReward" },
        { "CategoryID": 1223, "CategoryTitle": "不可开", "CategoryCode": "NotOpen" }
    ],
    "CodingRule": [
        { "CategoryID": 1224, "CategoryTitle": "无需换编码", "CategoryCode": "NoCodingRequired" },
        { "CategoryID": 1225, "CategoryTitle": "换编码出票", "CategoryCode": "CodeOut" },
        { "CategoryID": 1226, "CategoryTitle": "大编出票（无需换编）", "CategoryCode": "BigTicket" },
        { "CategoryID": 1227, "CategoryTitle": "大编出票（需换编）", "CategoryCode": "BigNoTicket" },
        { "CategoryID": 1228, "CategoryTitle": "无位不换出票（外放有位时换编）", "CategoryCode": "NoChange" }
    ],
    "InterVoyageType": [
        { "CategoryID": 1230, "CategoryTitle": "单程", "CategoryCode": "SingleVoyage" },
        { "CategoryID": 1231, "CategoryTitle": "往返", "CategoryCode": "RoundVoyage" },
        { "CategoryID": 1232, "CategoryTitle": "单程/往返", "CategoryCode": "SingleRound" }
    ],
    "PointsType": [
        { "CategoryID": 1306, "CategoryTitle": "直接修改", "CategoryCode": "DirectUpdate" },
        { "CategoryID": 1307, "CategoryTitle": "加点", "CategoryCode": "AddLittle" },
        { "CategoryID": 1308, "CategoryTitle": "减点", "CategoryCode": "ReduceLittle" }
    ],
    "AirlineType": [
        { "CategoryID": 1452, "CategoryTitle": "国内始发", "CategoryCode": "insideOutside" },
        { "CategoryID": 1453, "CategoryTitle": "直飞SOTO程", "CategoryCode": "outsideInside" },
        { "CategoryID": 1454, "CategoryTitle": "国内始发Add-On", "CategoryCode": "insideInsideOutside" },
        { "CategoryID": 1455, "CategoryTitle": "国外始发Add-On", "CategoryCode": "outsideInsideInside" },
        { "CategoryID": 1456, "CategoryTitle": "境外到境外", "CategoryCode": "outsideOutside" },
        { "CategoryID": 1457, "CategoryTitle": "国内始发中转", "CategoryCode": "insideOutsideOutside" },
        { "CategoryID": 1458, "CategoryTitle": "国外始发中转", "CategoryCode": "outsideOutsideInside" },
        { "CategoryID": 1459, "CategoryTitle": "境外境外境外", "CategoryCode": "outsideOutsideOutside" },
        { "CategoryID": 1460, "CategoryTitle": "境外境内境外", "CategoryCode": "outsideInsideOutside" },
        { "CategoryID": 1461, "CategoryTitle": "全球到全球", "CategoryCode": "globalGlobal" },
        { "CategoryID": 1462, "CategoryTitle": "全球中转全球", "CategoryCode": "globalGlobalGlobal" }
    ],
    "InformationsType": [
        { "CategoryID": 1471, "CategoryTitle": "预订须知", "CategoryCode": "TravelNotes" },
        { "CategoryID": 1472, "CategoryTitle": "费用须知", "CategoryCode": "ExpenseKnowledge" }
    ],
    "NotificationType": [
        { "CategoryID": 1473, "CategoryTitle": "短信", "CategoryCode": "ShortMessage" },
        { "CategoryID": 1474, "CategoryTitle": "邮件", "CategoryCode": "Mail" },
        { "CategoryID": 1475, "CategoryTitle": "微信", "CategoryCode": "Wechat" }
    ],
    "ExamineType": [
        { "CategoryID": 1476, "CategoryTitle": "审批订单消息内容", "CategoryCode": "EexamineOrderSms" },
        { "CategoryID": 1477, "CategoryTitle": "审批通过消息内容", "CategoryCode": "EexamineApprovalSms" },
        { "CategoryID": 1478, "CategoryTitle": "审批拒绝消息内容", "CategoryCode": "EexamineRefuseSms" },
        { "CategoryID": 1479, "CategoryTitle": "订单处理完成消息内容", "CategoryCode": "EexamineAccomplishSms" },
        { "CategoryID": 1480, "CategoryTitle": "退款完成", "CategoryCode": "Refunds" }
    ],
    "TrainSeatType": [
        { "CategoryID": 1485, "CategoryTitle": "商务座", "CategoryCode": "BusinessSeat" },
        { "CategoryID": 1486, "CategoryTitle": "特等座", "CategoryCode": "SpecialSeat" },
        { "CategoryID": 1487, "CategoryTitle": "一等座", "CategoryCode": "Level1Seat" },
        { "CategoryID": 1488, "CategoryTitle": "二等座", "CategoryCode": "Level2Seat" },
        { "CategoryID": 1489, "CategoryTitle": "高级软卧", "CategoryCode": "HighGradeSleeper" },
        { "CategoryID": 1490, "CategoryTitle": "软卧", "CategoryCode": "CommonSleeper" },
        { "CategoryID": 1491, "CategoryTitle": "硬卧", "CategoryCode": "HardSleeper" },
        { "CategoryID": 1492, "CategoryTitle": "软座", "CategoryCode": "SoftSeat" },
        { "CategoryID": 1493, "CategoryTitle": "硬座", "CategoryCode": "HardSeat" },
        { "CategoryID": 1494, "CategoryTitle": "无座", "CategoryCode": "NotHaveSeat" },
        { "CategoryID": 1495, "CategoryTitle": "动卧", "CategoryCode": "MotionSupine" },
        { "CategoryID": 1497, "CategoryTitle": "一等软卧", "CategoryCode": "Level1Sleeper" },
        { "CategoryID": 1499, "CategoryTitle": "二等软卧", "CategoryCode": "Level2Sleeper" }
    ],
    "Cabin": [
        { "CategoryID": 1496, "CategoryTitle": "经济舱", "CategoryCode": "Economy" },
        { "CategoryID": 1498, "CategoryTitle": "商务舱", "CategoryCode": "Buissenes" },
        { "CategoryID": 1500, "CategoryTitle": "头等舱", "CategoryCode": "First" },
        { "CategoryID": 1859, "CategoryTitle": "经济舱(9折)", "CategoryCode": "Economy9" },
        { "CategoryID": 1857, "CategoryTitle": "经济舱(8折)", "CategoryCode": "Economy8" },
        { "CategoryID": 1855, "CategoryTitle": "经济舱(7折)", "CategoryCode": "Economy7" },
        { "CategoryID": 1853, "CategoryTitle": "经济舱(6折)", "CategoryCode": "Economy6" },
        { "CategoryID": 1851, "CategoryTitle": "经济舱(5折)", "CategoryCode": "Economy5" }
    ],
    "LowestRule": [
        { "CategoryID": 0, "CategoryTitle": "无限制", "CategoryCode": "NoLimit" },
        { "CategoryID": 1501, "CategoryTitle": "相对最低价", "CategoryCode": "ControLowestPrice" },
        { "CategoryID": 1502, "CategoryTitle": "全天最低价", "CategoryCode": "DayLowestPrice" },
        { "CategoryID": 1503, "CategoryTitle": "时段最低价", "CategoryCode": "TimeAreaLowestPrice" },
        { "CategoryID": 1504, "CategoryTitle": "航班最低价", "CategoryCode": "FlightLowestPrice" }
    ],
    "TrainType": [
        { "CategoryID": 1505, "CategoryTitle": "高铁", "CategoryCode": "HighSpeedRail" },
        { "CategoryID": 1506, "CategoryTitle": "卧铺", "CategoryCode": "SleepingBerth" },
        { "CategoryID": 1507, "CategoryTitle": "普车及其它", "CategoryCode": "Other" }
    ],
    "TrafficGrade": [
        { "CategoryID": 2131, "CategoryTitle": "经济型", "CategoryCode": "Economy" },
        { "CategoryID": 2133, "CategoryTitle": "舒适型", "CategoryCode": "Comfort" },
        { "CategoryID": 2135, "CategoryTitle": "商务型", "CategoryCode": "Business" },
        { "CategoryID": 2137, "CategoryTitle": "豪华型", "CategoryCode": "Luxury" },
    ],
    "ServiceSecne": [
        { "CategoryID": 2121, "CategoryTitle": "商务用车", "CategoryCode": "Business" },
        { "CategoryID": 2123, "CategoryTitle": "加班用车", "CategoryCode": "Work" },
        { "CategoryID": 2125, "CategoryTitle": "出差用车", "CategoryCode": "Btrip" },
        { "CategoryID": 2127, "CategoryTitle": "其他场景", "CategoryCode": "Other" },
    ],
    "ApplicableCase": [
        { "CategoryID": 1508, "CategoryTitle": "全部", "CategoryCode": "Whole" },
        { "CategoryID": 1509, "CategoryTitle": "职位", "CategoryCode": "Position" },
        { "CategoryID": 1510, "CategoryTitle": "部门", "CategoryCode": "Department" }
    ],
    "CollectFeesType": [
        { "CategoryID": 1511, "CategoryTitle": "按固定收费", "CategoryCode": "FlatFeeCharges" },
        { "CategoryID": 1512, "CategoryTitle": "按百分比收费", "CategoryCode": "PercentageCostFee" }
    ],
    "TravelReasonType": [
        { "CategoryID": 1515, "CategoryTitle": "差旅目的", "CategoryCode": "TravelPurpose" },
        { "CategoryID": 1516, "CategoryTitle": "违背原因", "CategoryCode": "PolicyCause" },
        { "CategoryID": 1528, "CategoryTitle": "预订须知", "CategoryCode": "BookingInfo" }
    ],
    "FlightRefundReason": [
        { "CategoryID": 1517, "CategoryTitle": "我要改变行程,不想飞了", "CategoryCode": "FlightChange" },
        { "CategoryID": 1518, "CategoryTitle": "记错行程、日期、时间、姓名", "CategoryCode": "FlightMistaken" },
        { "CategoryID": 1519, "CategoryTitle": "航班延误或取消", "CategoryCode": "FlightDelay" }
    ],
    "BookingType": [
        { "CategoryID": 1529, "CategoryTitle": "因公", "CategoryCode": "OnBusiness" },
        { "CategoryID": 1530, "CategoryTitle": "因私", "CategoryCode": "OnPersonal" }
    ],
    "ApprovalRecordType": [
        { "CategoryID": 1531, "CategoryTitle": "订单支付审批", "CategoryCode": "PayApproval" },
        { "CategoryID": 1532, "CategoryTitle": "订单改签审批", "CategoryCode": "ChangeApproval" },
        { "CategoryID": 1533, "CategoryTitle": "订单退票审批", "CategoryCode": "ReturnTicketApproval" }
    ],
    "ReservationMode": [
        { "CategoryID": 1536, "CategoryTitle": "线上预订", "CategoryCode": "OnLineReservation" },
        { "CategoryID": 1537, "CategoryTitle": "线下预订", "CategoryCode": "OffLineReservation" }
    ],
    "ServiceTimeType": [
        { "CategoryID": 1538, "CategoryTitle": "工作时间", "CategoryCode": "WorkingTime" },
        { "CategoryID": 1539, "CategoryTitle": "非工作时间", "CategoryCode": "NonWorkingTime" }
    ],
    "TripApprovalRule": [
        { "CategoryID": 1541, "CategoryTitle": "线上预订需要审批", "CategoryCode": "OnlineBookingApproval" },
        { "CategoryID": 1542, "CategoryTitle": "线下预订需要审批", "CategoryCode": "OfflineBookingApproval" },
        { "CategoryID": 1545, "CategoryTitle": "违背规则需要审批", "CategoryCode": "ViolateRuleApproval" },
        { "CategoryID": 1546, "CategoryTitle": "更改行程需要审批", "CategoryCode": "ChangeTripApproval" },
        { "CategoryID": 1547, "CategoryTitle": "取消行程需要审批", "CategoryCode": "CancelTripApproval" },
        { "CategoryID": 1543, "CategoryTitle": "必需选择成本中心", "CategoryCode": "CostCenterRequire" },
        { "CategoryID": 1544, "CategoryTitle": "必需填写项目代码", "CategoryCode": "ProjectCodeRequire" },
        { "CategoryID": 1540, "CategoryTitle": "必需填写违背原因", "CategoryCode": "ContraryReasonRequire" },
        { "CategoryID": 1580, "CategoryTitle": "必需填写差旅目的", "CategoryCode": "IntentTripApproval" },
        { "CategoryID": 1582, "CategoryTitle": "必需填写审批单号", "CategoryCode": "ApprovalNoRequire" },
        { "CategoryID": 1584, "CategoryTitle": "允许填写审批单号", "CategoryCode": "ApprovalDisplayOnly" },
        { "CategoryID": 1585, "CategoryTitle": "允许代用审批规则", "CategoryCode": "UseSelfApproval" },
        { "CategoryID": 1587, "CategoryTitle": "或签可以选审批人", "CategoryCode": "ChooseApprovalOptional" },
        { "CategoryID": 1588, "CategoryTitle": "或签必需选审批人", "CategoryCode": "ChooseApprovalRequired" },
        { "CategoryID": 1589, "CategoryTitle": "无需填写项目代码", "CategoryCode": "ProjectCodeOptional" },
        { "CategoryID": 1591, "CategoryTitle": "禁止预定机票服务", "CategoryCode": "DisableBookingFlight" },
        { "CategoryID": 1593, "CategoryTitle": "禁止预定酒店服务", "CategoryCode": "DisableBookingHotel" },
        { "CategoryID": 1595, "CategoryTitle": "禁止预定火车服务", "CategoryCode": "DisableBookingTrain" },
        { "CategoryID": 1597, "CategoryTitle": "需要验证审批单号", "CategoryCode": "CheckApprovalNo" },
        { "CategoryID": 1599, "CategoryTitle": "禁用填写差旅目的", "CategoryCode": "DisableIntentTripApproval" },
        { "CategoryID": 1601, "CategoryTitle": "必需选择预算编码", "CategoryCode": "requireBudgetCode" },
        { "CategoryID": 1603, "CategoryTitle": "必需上传订单附件", "CategoryCode": "requireOrderAttach" },
        { "CategoryID": 1605, "CategoryTitle": "允许上传订单附件", "CategoryCode": "allowOrderAttach" },
    ],
    "FlightTimeStatus": [
        { "CategoryID": 1548, "CategoryTitle": "起飞前", "CategoryCode": "Preflight" },
        { "CategoryID": 1549, "CategoryTitle": "起飞后", "CategoryCode": "AfterTakeoff" }
    ],
    "RuleType": [
        { "CategoryID": 1550, "CategoryTitle": "改签", "CategoryCode": "RuleEndorse" },
        { "CategoryID": 1551, "CategoryTitle": "退票", "CategoryCode": "RuleFund" },
        { "CategoryID": 1553, "CategoryTitle": "预订", "CategoryCode": "Reserve" }
    ],
    "ExpensesType": [
        { "CategoryID": 1534, "CategoryTitle": "按人收费", "CategoryCode": "People" },
        { "CategoryID": 1535, "CategoryTitle": "按产品收费", "CategoryCode": "legs" }
    ],
    "DelayType": [
        { "CategoryID": 1559, "CategoryTitle": "自愿", "CategoryCode": "Volunteer" },
        { "CategoryID": 1561, "CategoryTitle": "航变", "CategoryCode": "FlightChang" },
        { "CategoryID": 1563, "CategoryTitle": "重购", "CategoryCode": "BuyAgain" },
        { "CategoryID": 1565, "CategoryTitle": "病退", "CategoryCode": "SickAmend" },
        { "CategoryID": 1567, "CategoryTitle": "名字错误", "CategoryCode": "NameError" },
        { "CategoryID": 1569, "CategoryTitle": "升舱换开", "CategoryCode": "CabinChange" },
        { "CategoryID": 1571, "CategoryTitle": "废票", "CategoryCode": "TicketInvalid" },
        { "CategoryID": 1573, "CategoryTitle": "其他", "CategoryCode": "Other" }
    ],
    "CompanyCard": [
        { "CategoryID": 1720, "CategoryTitle": "营业执照", "CategoryCode": "BusinessLicence" },
        { "CategoryID": 1722, "CategoryTitle": "税务登记证", "CategoryCode": "TaxRegistration" },
        { "CategoryID": 1730, "CategoryTitle": "其他", "CategoryCode": "Other" },
    ],
    "ActiveStatus": [
        { "CategoryID": 1750, "CategoryTitle": "待审批", "CategoryCode": "WaitSubmit" },
        { "CategoryID": 1752, "CategoryTitle": "待审批", "CategoryCode": "WaitDispose" },
        { "CategoryID": 1754, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" },
        { "CategoryID": 1756, "CategoryTitle": "已完成", "CategoryCode": "Finished" },
        { "CategoryID": 1758, "CategoryTitle": "已拒绝", "CategoryCode": "Rejected" },
    ],
    "PriceType": [
        { "CategoryID": 1672, "CategoryTitle": "房费", "CategoryCode": "HotelFare" },
        { "CategoryID": 1674, "CategoryTitle": "团费", "CategoryCode": "TeamFare" },
        { "CategoryID": 1660, "CategoryTitle": "票面", "CategoryCode": "TicketFare" },
        { "CategoryID": 1662, "CategoryTitle": "机建", "CategoryCode": "BuildFare" },
        { "CategoryID": 1664, "CategoryTitle": "燃油", "CategoryCode": "FuelFare" },
        { "CategoryID": 1666, "CategoryTitle": "税费", "CategoryCode": "TaxFare" },
        { "CategoryID": 1692, "CategoryTitle": "直减", "CategoryCode": "DirectReduction" },
        { "CategoryID": 1668, "CategoryTitle": "保险", "CategoryCode": "SafeFare" },
        { "CategoryID": 1670, "CategoryTitle": "服务费", "CategoryCode": "ServiceFare" },
        { "CategoryID": 1678, "CategoryTitle": "退票", "CategoryCode": "AmendFare" },
        { "CategoryID": 1682, "CategoryTitle": "变更", "CategoryCode": "ChangeFare" },
        { "CategoryID": 1684, "CategoryTitle": "原价", "CategoryCode": "OldPrice" },
        { "CategoryID": 1690, "CategoryTitle": "其它", "CategoryCode": "OtherFare" },
        { "CategoryID": 1694, "CategoryTitle": "折扣", "CategoryCode": "ThrowDiscount" },
    ],
    "FlowMode": [
        { "CategoryID": 1760, "CategoryTitle": "交易审批", "CategoryCode": "Bill" },
    ],
    "AccountType":[
        { "CategoryID": 1765, "CategoryTitle": "余额", "CategoryCode": "Balance" },
        { "CategoryID": 1767, "CategoryTitle": "信用", "CategoryCode": "Credit" },
        { "CategoryID": 1769, "CategoryTitle": "积分", "CategoryCode": "Integral" },
    ],
    "CreditType":[
        { "CategoryID": 1771, "CategoryTitle": "固定授信", "CategoryCode": "FixedCredit" },
        { "CategoryID": 1773, "CategoryTitle": "临时授信", "CategoryCode": "InterimCredit" },
    ],
    "BillStatus":[
        { "CategoryID": 1777, "CategoryTitle": "待出帐", "CategoryCode": "WaitOutDay" },
        { "CategoryID": 1779, "CategoryTitle": "待审核", "CategoryCode": "WaitAudited" },
        { "CategoryID": 1781, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" },
        { "CategoryID": 1783, "CategoryTitle": "待收款", "CategoryCode": "WaitReceive" },
        { "CategoryID": 1785, "CategoryTitle": "已关账", "CategoryCode": "Finished" },
        { "CategoryID": 1787, "CategoryTitle": "已退回", "CategoryCode": "Rejected" },
    ],
    "PaymentType":[
        { "CategoryID": 1195, "CategoryTitle": "预付", "CategoryCode": "Prepay" },
        { "CategoryID": 1196, "CategoryTitle": "现付", "CategoryCode": "CashPay" },
    ],
    "HotelRefundReason":[
        { "CategoryID": 1805, "CategoryTitle": "行程变更", "CategoryCode": "HotelChange" },
        { "CategoryID": 1837, "CategoryTitle": "行程取消", "CategoryCode": "HotelDelay" },
    ],
    "InvoiceRole":[
        { "CategoryID": 1813, "CategoryTitle": "公司", "CategoryCode": "Company" },
        { "CategoryID": 1815, "CategoryTitle": "个人", "CategoryCode": "People" },
    ],
    "InvoiceType":[
        { "CategoryID": 1821, "CategoryTitle": "专用发票", "CategoryCode": "SpecialTicket" },
        { "CategoryID": 1823, "CategoryTitle": "普通发票", "CategoryCode": "GeneralTicket" },
    ],
    'TakeType':[
        { "CategoryID": 1825, "CategoryTitle": "电子发票", "CategoryCode": "Electronic" },
        { "CategoryID": 1827, "CategoryTitle": "纸质发票", "CategoryCode": "Paper" },
    ],
    'NotifyType':[
        { "CategoryID": 1865, "CategoryTitle": "短信通知", "CategoryCode": "MessageNotify" },
        { "CategoryID": 1867, "CategoryTitle": "邮件通知", "CategoryCode": "MailNotify" },
        { "CategoryID": 1869, "CategoryTitle": "微信通知", "CategoryCode": "WechatNotify" },
        { "CategoryID": 1871, "CategoryTitle": "App通知", "CategoryCode": "AppNotify" },
        { "CategoryID": 1873, "CategoryTitle": "OA通知", "CategoryCode": "OANotify" },
    ],
    'OverdueStatus':[
        { "CategoryID": 1890, "CategoryTitle": "待出帐", "CategoryCode": "WaitOutDay" },
        { "CategoryID": 1892, "CategoryTitle": "未逾期", "CategoryCode": "OverdueNo" },
        { "CategoryID": 1894, "CategoryTitle": "已逾期", "CategoryCode": "OverdueYes" },
    ],
    'SaleRuleType':[
        { "CategoryID": 1900, "CategoryTitle": "百分比", "CategoryCode": "Percentage" },
        { "CategoryID": 1902, "CategoryTitle": "固定金额", "CategoryCode": "FixMoney" },
        { "CategoryID": 1904, "CategoryTitle": "剔除最低舱位", "CategoryCode": "RemovePrice" },
    ],
    'AuthType':[
        { "CategoryID": 10220, "CategoryTitle": "邮箱账号", "CategoryCode": "EmailAuth" },
        { "CategoryID": 10222, "CategoryTitle": "手机账号", "CategoryCode": "MobileAuth" },
        { "CategoryID": 10224, "CategoryTitle": "账号密码", "CategoryCode": "AccountAuth" },
        { "CategoryID": 10230, "CategoryTitle": "微信授权", "CategoryCode": "WeixinAuth" },
        { "CategoryID": 10250, "CategoryTitle": "动态密码", "CategoryCode": "DynamicAuth" },
    ],
    'NotifyContentType':[
        { "CategoryID": 1940, "CategoryTitle": "文本", "CategoryCode": "Text" },
        { "CategoryID": 1945, "CategoryTitle": "HTML", "CategoryCode": "Html" },
        { "CategoryID": 1950, "CategoryTitle": "链接", "CategoryCode": "Link" },
        { "CategoryID": 1955, "CategoryTitle": "插件", "CategoryCode": "Plugin" },
    ],
    'NotifyScope':[
        { "CategoryID": 1960, "CategoryTitle": "公司内部", "CategoryCode": "CompanyInternal" },
        { "CategoryID": 1962, "CategoryTitle": "当前域名", "CategoryCode": "CurrentDomainName" },
        { "CategoryID": 1964, "CategoryTitle": "所有域名", "CategoryCode": "AllDomainName" },
    ],
    'ExpressType':[
        { "CategoryID": 1970, "CategoryTitle": "电子邮件", "CategoryCode": "Email" },
        { "CategoryID": 1972, "CategoryTitle": "普通地址", "CategoryCode": "OrdinaryAddress" },
    ],

    'ExtraCode_Wechat':[
        {"CategoryCode":"wechat_receive_reply", "CategoryTitle":"默认回复"},
        {"CategoryCode":"wechat_watch_reply","CategoryTitle":"关注回复"}],
    'BaggageCode':[
        {"CategoryID": 1975,"CategoryCode":"carryon", "CategoryTitle":"手提"},
        {"CategoryID": 1976,"CategoryCode":"consign","CategoryTitle":"托运"}
    ],
};

data["OrderStatus"] = [
    { "CategoryID": 10101, "CategoryTitle": "待预订", "CategoryCode": "WaitBooking" },
    // { "CategoryID": 10103, "CategoryTitle": "待审批", "CategoryCode": "WaitApprove" },
    { "CategoryID": 10105, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" },
    { "CategoryID": 10107, "CategoryTitle": "待支付", "CategoryCode": "WaitPayment" },
    { "CategoryID": 10109, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" },
    { "CategoryID": 10113, "CategoryTitle": "已完成", "CategoryCode": "Finished" },
    { "CategoryID": 10115, "CategoryTitle": "已取消", "CategoryCode": "Canceled" },
    { "CategoryID": 10117, "CategoryTitle": "已退回", "CategoryCode": "Rejected" },
    // { "CategoryID": 10119, "CategoryTitle": "已拆分", "CategoryCode": "Discrete" },
    { "CategoryID": 10121, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" },
];

data["DealStatus"] = [
    // { "CategoryID": 3010301, "CategoryTitle": "待预订", "CategoryCode": "WaitBooking" },
    // { "CategoryID": 3010303, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" },
    // { "CategoryID": 3010305, "CategoryTitle": "待付款", "CategoryCode": "WaitPayment" },
    // { "CategoryID": 3010307, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" },
    // { "CategoryID": 3010311, "CategoryTitle": "已完成", "CategoryCode": "Finished" },
    // { "CategoryID": 3010313, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" },
    // { "CategoryID": 3010315, "CategoryTitle": "已退回", "CategoryCode": "Rejected" },
    // { "CategoryID": 3010317, "CategoryTitle": "已取消", "CategoryCode": "Canceled" },
    { "CategoryID": 10101, "CategoryTitle": "待预订", "CategoryCode": "WaitBooking" },
    // { "CategoryID": 10103, "CategoryTitle": "待审批", "CategoryCode": "WaitApprove" },
    { "CategoryID": 10105, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" },
    { "CategoryID": 10107, "CategoryTitle": "待支付", "CategoryCode": "WaitPayment" },
    { "CategoryID": 10109, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" },
    { "CategoryID": 10113, "CategoryTitle": "已完成", "CategoryCode": "Finished" },
    { "CategoryID": 10115, "CategoryTitle": "已取消", "CategoryCode": "Canceled" },
    { "CategoryID": 10117, "CategoryTitle": "已退回", "CategoryCode": "Rejected" },
    // { "CategoryID": 10119, "CategoryTitle": "已拆分", "CategoryCode": "Discrete" },
    { "CategoryID": 10121, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" },
];
data["AmendStatus"] = [
    { "CategoryID": 10201, "CategoryTitle": "待提交", "CategoryCode": "WaitSubmit" },
    { "CategoryID": 10203, "CategoryTitle": "待核价", "CategoryCode": "WaitDispose" },
    { "CategoryID": 10205, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" },
    { "CategoryID": 10209, "CategoryTitle": "待退款", "CategoryCode": "WaitRefund" },
    { "CategoryID": 10213, "CategoryTitle": "已完成", "CategoryCode": "Finished" },
    { "CategoryID": 10215, "CategoryTitle": "暂不能", "CategoryCode": "Cannot" },
    { "CategoryID": 10217, "CategoryTitle": "已退回", "CategoryCode": "Rejected" },
    { "CategoryID": 10221, "CategoryTitle": "已取消", "CategoryCode": "Canceled" },
];

data["FlightPolicyState"] = [
    { "CategoryID": 3070101, "CategoryTitle": "待审批", "CategoryCode": "FlightWaitPolicy" },
    { "CategoryID": 3070102, "CategoryTitle": "已上线", "CategoryCode": "FlightOnlinePolicy" },
    { "CategoryID": 3070103, "CategoryTitle": "已下线", "CategoryCode": "FlightDownPolicy" },
    { "CategoryID": 3070104, "CategoryTitle": "已禁用", "CategoryCode": "FlightDisablePolicy" },
];
data["PolicyState"] = [
    { "CategoryID": 3010101, "CategoryTitle": "待审批", "CategoryCode": "FlightWaitPolicy" },
    { "CategoryID": 3010103, "CategoryTitle": "已上线", "CategoryCode": "FlightOnlinePolicy" },
    { "CategoryID": 3010105, "CategoryTitle": "已下线", "CategoryCode": "FlightDownPolicy" },
    { "CategoryID": 3010107, "CategoryTitle": "已禁用", "CategoryCode": "FlightDisablePolicy" },
];
data["Lang"]=[
    {"CategoryID":'cn',"CategoryTitle":'中文',"CategoryCode":"cn"},
    {"CategoryID":'en',"CategoryTitle":'英文',"CategoryCode":"en"},
    {"CategoryID":'jp',"CategoryTitle":'日文',"CategoryCode":"jp"},
]

data["SupplyCode"]=[
    {"CategoryTitle":"IBE","CategoryCode":"IBE"},
    {"CategoryTitle":"Qunar","CategoryCode":"Qunar"},
]
data["ChannelCode"]=[
    {"CategoryTitle":"网站","CategoryCode":"web"},
    {"CategoryTitle":"手机","CategoryCode":"app"},
    {"CategoryTitle":"微信","CategoryCode":"h5"},
    {"CategoryTitle":"门店","CategoryCode":"store"},
    {"CategoryTitle":"客服","CategoryCode":"emp"}
]
data["Numbers"] = [
    { "CategoryID": 1, "CategoryTitle": "单", "CategoryCode": "一" },
    { "CategoryID": 2, "CategoryTitle": "双", "CategoryCode": "二" },
    { "CategoryID": 3, "CategoryTitle": "三", "CategoryCode": "三" },
    { "CategoryID": 4, "CategoryTitle": "四", "CategoryCode": "四" },
    { "CategoryID": 5, "CategoryTitle": "五", "CategoryCode": "五" },
    { "CategoryID": 6, "CategoryTitle": "六", "CategoryCode": "六" },
    { "CategoryID": 7, "CategoryTitle": "七", "CategoryCode": "七" },
    { "CategoryID": 8, "CategoryTitle": "八", "CategoryCode": "八" },
    { "CategoryID": 9, "CategoryTitle": "九", "CategoryCode": "九" },
    { "CategoryID": 0, "CategoryTitle": "无", "CategoryCode": "零" },
]
data['FlightChangeStatus']=[
    { "CategoryID": 10301, "CategoryTitle": "待通知", "CategoryCode": "WaitNotify" },
    { "CategoryID": 10303, "CategoryTitle": "待确认", "CategoryCode": "WaitConfirm" },
    { "CategoryID": 10305, "CategoryTitle": "待处理", "CategoryCode": "WaitDispose" },
    { "CategoryID": 10307, "CategoryTitle": "已完成", "CategoryCode": "Finished" }
]


data.types = {};
data.codes = {};
for (var key in data) {
    if (data.hasOwnProperty(key)) {
        var eles = data[key];
        let types = {};
        let codes = {};
        data.types[key] = types;
        data.codes[key] = codes;
        for (var i = 0; i < eles.length; i++) {
            types[eles[i].CategoryCode] = eles[i].CategoryID;
            codes[eles[i].CategoryID] = eles[i].CategoryCode;
        }
    }
}

export default data;



// WEBPACK FOOTER //
// ./src/utils/categorys.js